if (!customElements.get('variant-specs')) {
    customElements.define('variant-specs', class VariantSpecs extends HTMLElement {
        constructor() {
            super();

            // if no specs are given in html destroy component and tab
            if (this.childNodes.length === 0) this.destroySpecs();

            const variantChangeElements = document.querySelector('variant-radios') || document.querySelector('variant-selects');
            if (variantChangeElements) {
                variantChangeElements.addEventListener('change', this.onVariantChange.bind(this));
            }
        }

        onVariantChange(event) {
            const variantId = event.srcElement.dataset.variantId;
            if (!variantId) return
            
            const variantSpecTable = this.querySelector(`[id=variant-specs-for-${variantId}]`);
            if (!variantSpecTable) return;

            this.hideAllSpecs();
            variantSpecTable.classList.remove('d-none');
        }

        hideAllSpecs() {
            const allSpecTables = this.querySelectorAll('[id^=variant-specs-for]')
            allSpecTables.forEach((specTable) => specTable.classList.add('d-none'));
        }

        destroySpecs() {
            const tabContent = this.closest('.tab-content');
            const tabId = tabContent?.id;
            const tabTitle = document.querySelector(`.tab-title[href="#${tabId}"]`);
            const tabTitleParent = tabTitle.closest('.tab');

            // open next tab title and content
            tabTitleParent.nextSibling?.querySelector('.tab-title')?.classList?.add('is-open');
            tabContent.nextSibling?.classList.add('is-active');

            // remove variant specs tab title and content
            tabTitleParent.remove();
            tabContent.remove();
        }
    });
}